import { render } from "./GastroPanelSelectedTests.vue?vue&type=template&id=767ef2d4"
import script from "./GastroPanelSelectedTests.vue?vue&type=script&lang=js"
export * from "./GastroPanelSelectedTests.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/cases/testInfo/selectedTestsPreview/GastroPanelSelectedTests.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "767ef2d4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('767ef2d4', __exports__)) {
    console.log('reload')
    api.reload('767ef2d4', __exports__)
  }
  
  module.hot.accept("./GastroPanelSelectedTests.vue?vue&type=template&id=767ef2d4", () => {
    console.log('re-render')
    api.rerender('767ef2d4', render)
  })

}


export default __exports__